module.exports = __webpack_public_path__ + "static/media/karachi-r4.9cc739fe.svg";